export interface PointLightProps {
  position: [x: number, y: number, z: number];
  intensity: number;
  decay: number;
  distance?: number;
}

export const defaultPointLights: PointLightProps[] = [
  { position: [0, 2000, 0], decay: 0, intensity: Math.PI, distance: 0 },
  { position: [1000, 2000, 1000], decay: 0, intensity: Math.PI, distance: 0 },
  { position: [2000, 0, 0], decay: 0, intensity: Math.PI, distance: 0 },
];
